import { default as indexUUQIwLg0NQMeta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/certificates/[id]/index.vue?macro=true";
import { default as shareWbtjZyOkoeMeta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/certificates/[id]/share.vue?macro=true";
import { default as _91slug_936iQoKtTosGMeta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/dashboard/bootcamp/[slug].vue?macro=true";
import { default as indexLyGJday1X0Meta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/dashboard/bootcamp/index.vue?macro=true";
import { default as indexkDasrO07KbMeta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/dashboard/exam/index.vue?macro=true";
import { default as indexkvTLuIRDUXMeta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/dashboard/free-weekend/index.vue?macro=true";
import { default as _91slug_93iRnrZ4AAHvMeta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/dashboard/guides/[slug].vue?macro=true";
import { default as indexiZW3YE9zQ3Meta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/dashboard/guides/index.vue?macro=true";
import { default as indexqFt8UI9bQoMeta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/dashboard/index.vue?macro=true";
import { default as index1IBIw4IcL4Meta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/dashboard/profile/index.vue?macro=true";
import { default as _91slug_93Ti1BDhin6mMeta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/dashboard/training/[slug].vue?macro=true";
import { default as indexVYKKZGzcBLMeta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/dashboard/training/index.vue?macro=true";
import { default as indexmh4NroGswmMeta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/dashboard/upgrades/index.vue?macro=true";
import { default as index3T8DDiphUYMeta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/dashboard/vouchers/index.vue?macro=true";
import { default as _91challenge_93NSfiebbjtQMeta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/editor/[challenge].vue?macro=true";
import { default as disputeSwVgtNxJvEMeta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/exam/[id]/dispute.vue?macro=true";
import { default as doneEW89200sdmMeta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/exam/[id]/done.vue?macro=true";
import { default as progressXf2fjnN2GtMeta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/exam/[id]/progress.vue?macro=true";
import { default as rulesSIRaSEz7qCMeta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/exam/[id]/rules.vue?macro=true";
import { default as startpjdeNJ66bjMeta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/exam/[id]/start.vue?macro=true";
import { default as termsfV0YclFPFUMeta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/exam/[id]/terms.vue?macro=true";
import { default as indexiRLgjIOHJuMeta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/free-weekend/index.vue?macro=true";
import { default as pollTDOb9HQ0MZMeta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/free-weekend/poll.vue?macro=true";
import { default as successLpuXJbMtyLMeta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/free-weekend/success.vue?macro=true";
import { default as indexkanhUUjdTZMeta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/login/index.vue?macro=true";
import { default as indexB1laFWx3AuMeta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/logout/index.vue?macro=true";
import { default as check_45email9kaY9TuF2jMeta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/password-recover/check-email.vue?macro=true";
import { default as indexEr4Dg2fSEWMeta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/password-recover/index.vue?macro=true";
import { default as successMnpJUSBWxMMeta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/password-recover/success.vue?macro=true";
import { default as _91token_93xY5f3RmgsgMeta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/password-reset/[token].vue?macro=true";
import { default as _91token_93ibSiM1IO65Meta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/password-set/[token].vue?macro=true";
import { default as mcqAPiSPyBnSIMeta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/preview/[secret]/mcq.vue?macro=true";
import { default as indexyXXIGdyFV8Meta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/register/index.vue?macro=true";
import { default as done7wmN4393pWMeta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/trial-exams/[id]/done.vue?macro=true";
import { default as progressN8tZfOpVCAMeta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/trial-exams/[id]/progress.vue?macro=true";
import { default as resultsNPp6CbdBa5Meta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/trial-exams/[id]/results.vue?macro=true";
import { default as rulesYOM3uaWIayMeta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/trial-exams/[id]/rules.vue?macro=true";
import { default as startXQvK9jTWhnMeta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/trial-exams/[id]/start.vue?macro=true";
import { default as termsakxJY1BCjvMeta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/trial-exams/[id]/terms.vue?macro=true";
import { default as _91hash_93J0C5xwZCNKMeta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/verify-email/[id]/[hash].vue?macro=true";
import { default as _91code_934Arf272LANMeta } from "/home/runner/work/certificates-app/certificates-app/pages/[tech]/voucher/[code].vue?macro=true";
import { default as indexrjHO63KsAoMeta } from "/home/runner/work/certificates-app/certificates-app/pages/angular/index.vue?macro=true";
import { default as _91slug_93jf14EWkzQkMeta } from "/home/runner/work/certificates-app/certificates-app/pages/angular/legal/[slug].vue?macro=true";
import { default as successyU3zO6O0CBMeta } from "/home/runner/work/certificates-app/certificates-app/pages/angular/success.vue?macro=true";
import { default as _91slug_93XkW6otCMaQMeta } from "/home/runner/work/certificates-app/certificates-app/pages/blog/[slug].vue?macro=true";
import { default as index0FkMs6PoBQMeta } from "/home/runner/work/certificates-app/certificates-app/pages/blog/index.vue?macro=true";
import { default as shareR7m8zC1pGfMeta } from "/home/runner/work/certificates-app/certificates-app/pages/certificates/[id]/share.vue?macro=true";
import { default as indexZZQPfMAqRbMeta } from "/home/runner/work/certificates-app/certificates-app/pages/certificates/index.vue?macro=true";
import { default as successt4j0sKKOEoMeta } from "/home/runner/work/certificates-app/certificates-app/pages/checkout/success.vue?macro=true";
import { default as free_45weekendi9pswk92FuMeta } from "/home/runner/work/certificates-app/certificates-app/pages/free-weekend.vue?macro=true";
import { default as homefr0HXFBRvVMeta } from "/home/runner/work/certificates-app/certificates-app/pages/home.vue?macro=true";
import { default as index0y7rHUPnrVMeta } from "/home/runner/work/certificates-app/certificates-app/pages/index.vue?macro=true";
import { default as indexgYIw8TfuAJMeta } from "/home/runner/work/certificates-app/certificates-app/pages/javascript/index.vue?macro=true";
import { default as _91slug_93RVNQ1VjECsMeta } from "/home/runner/work/certificates-app/certificates-app/pages/javascript/legal/[slug].vue?macro=true";
import { default as successFd0PRBMAjMMeta } from "/home/runner/work/certificates-app/certificates-app/pages/javascript/success.vue?macro=true";
import { default as index0rVBxejX9wMeta } from "/home/runner/work/certificates-app/certificates-app/pages/join-team/index.vue?macro=true";
import { default as _91slug_93VSgSim9uBpMeta } from "/home/runner/work/certificates-app/certificates-app/pages/legal/[slug].vue?macro=true";
import { default as _91_91tech_93_93HxuUC9EyqnMeta } from "/home/runner/work/certificates-app/certificates-app/pages/login/[provider]/callback/[[tech]].vue?macro=true";
import { default as logoutZSx9gpPVDZMeta } from "/home/runner/work/certificates-app/certificates-app/pages/logout.vue?macro=true";
import { default as indexZn5nKRVcewMeta } from "/home/runner/work/certificates-app/certificates-app/pages/nuxt/index.vue?macro=true";
import { default as _91slug_93EOiemm7DcqMeta } from "/home/runner/work/certificates-app/certificates-app/pages/nuxt/legal/[slug].vue?macro=true";
import { default as successe5WAbfgoMOMeta } from "/home/runner/work/certificates-app/certificates-app/pages/nuxt/success.vue?macro=true";
import { default as profilenZQ1WwZEe3Meta } from "/home/runner/work/certificates-app/certificates-app/pages/onboarding/profile.vue?macro=true";
import { default as press_45releaseK9yQFTgtIpMeta } from "/home/runner/work/certificates-app/certificates-app/pages/press-release.vue?macro=true";
import { default as profilewFOLcRvVXlMeta } from "/home/runner/work/certificates-app/certificates-app/pages/profile.vue?macro=true";
import { default as indexkCZ6sTs73zMeta } from "/home/runner/work/certificates-app/certificates-app/pages/react/index.vue?macro=true";
import { default as _91slug_93H2liFnGsBDMeta } from "/home/runner/work/certificates-app/certificates-app/pages/react/legal/[slug].vue?macro=true";
import { default as successp5SNYkSfyUMeta } from "/home/runner/work/certificates-app/certificates-app/pages/react/success.vue?macro=true";
import { default as soonEqZR7p9ANQMeta } from "/home/runner/work/certificates-app/certificates-app/pages/soon.vue?macro=true";
import { default as dashboardQaRmOxv6JFMeta } from "/home/runner/work/certificates-app/certificates-app/pages/team/dashboard.vue?macro=true";
import { default as manage1PXIUGSuo4Meta } from "/home/runner/work/certificates-app/certificates-app/pages/team/manage.vue?macro=true";
import { default as my_45dashboardi8ryeObos6Meta } from "/home/runner/work/certificates-app/certificates-app/pages/team/my-dashboard.vue?macro=true";
import { default as _91orderId_937noWx8iRXjMeta } from "/home/runner/work/certificates-app/certificates-app/pages/team/onboarding/[orderId].vue?macro=true";
import { default as progress56r8p6TrTPMeta } from "/home/runner/work/certificates-app/certificates-app/pages/team/progress.vue?macro=true";
import { default as vouchers9Jk3CP9BOJMeta } from "/home/runner/work/certificates-app/certificates-app/pages/team/vouchers.vue?macro=true";
import { default as indexHSysWWECFvMeta } from "/home/runner/work/certificates-app/certificates-app/pages/typescript/index.vue?macro=true";
import { default as successK93OzFIsvrMeta } from "/home/runner/work/certificates-app/certificates-app/pages/typescript/success.vue?macro=true";
import { default as indexef2MNgYDWXMeta } from "/home/runner/work/certificates-app/certificates-app/pages/voucher/[code]/index.vue?macro=true";
import { default as selectxC2j6ZRuK9Meta } from "/home/runner/work/certificates-app/certificates-app/pages/voucher/[code]/select.vue?macro=true";
import { default as indexFDZstyuCDsMeta } from "/home/runner/work/certificates-app/certificates-app/pages/vuejs/index.vue?macro=true";
import { default as _91slug_93UbcypnlyyzMeta } from "/home/runner/work/certificates-app/certificates-app/pages/vuejs/legal/[slug].vue?macro=true";
import { default as demoJIMPY8uvKmMeta } from "/home/runner/work/certificates-app/certificates-app/pages/vuejs/qa/demo.vue?macro=true";
import { default as indexPYojpkvvjkMeta } from "~/pages/[tech]/login/index.vue?macro=true";
import { default as indexJLtB69g55vMeta } from "~/pages/[tech]/register/index.vue?macro=true";
import { default as indexh1aW6lpbb4Meta } from "~/pages/[tech]/password-recover/index.vue?macro=true";
import { default as successwlFTWURnPUMeta } from "~/pages/[tech]/password-recover/success.vue?macro=true";
import { default as check_45emailFdYqrMlqFqMeta } from "~/pages/[tech]/password-recover/check-email.vue?macro=true";
import { default as _91token_93qLhw7WDmYUMeta } from "~/pages/[tech]/password-reset/[token].vue?macro=true";
import { default as _91token_93jn0cdb3ri6Meta } from "~/pages/[tech]/password-set/[token].vue?macro=true";
export default [
  {
    name: "tech-certificates-id",
    path: "/:tech()/certificates/:id()",
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/certificates/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "tech-certificates-id-share",
    path: "/:tech()/certificates/:id()/share",
    meta: shareWbtjZyOkoeMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/certificates/[id]/share.vue").then(m => m.default || m)
  },
  {
    name: "tech-dashboard-bootcamp-slug",
    path: "/:tech()/dashboard/bootcamp/:slug()",
    meta: _91slug_936iQoKtTosGMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/dashboard/bootcamp/[slug].vue").then(m => m.default || m)
  },
  {
    name: "tech-dashboard-bootcamp",
    path: "/:tech()/dashboard/bootcamp",
    meta: indexLyGJday1X0Meta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/dashboard/bootcamp/index.vue").then(m => m.default || m)
  },
  {
    name: "tech-dashboard-exam",
    path: "/:tech()/dashboard/exam",
    meta: indexkDasrO07KbMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/dashboard/exam/index.vue").then(m => m.default || m)
  },
  {
    name: "tech-dashboard-free-weekend",
    path: "/:tech()/dashboard/free-weekend",
    meta: indexkvTLuIRDUXMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/dashboard/free-weekend/index.vue").then(m => m.default || m)
  },
  {
    name: "tech-dashboard-guides-slug",
    path: "/:tech()/dashboard/guides/:slug()",
    meta: _91slug_93iRnrZ4AAHvMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/dashboard/guides/[slug].vue").then(m => m.default || m)
  },
  {
    name: "tech-dashboard-guides",
    path: "/:tech()/dashboard/guides",
    meta: indexiZW3YE9zQ3Meta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/dashboard/guides/index.vue").then(m => m.default || m)
  },
  {
    name: "tech-dashboard",
    path: "/:tech()/dashboard",
    meta: indexqFt8UI9bQoMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/dashboard/index.vue").then(m => m.default || m)
  },
  {
    name: "tech-dashboard-profile",
    path: "/:tech()/dashboard/profile",
    meta: index1IBIw4IcL4Meta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/dashboard/profile/index.vue").then(m => m.default || m)
  },
  {
    name: "tech-dashboard-training-slug",
    path: "/:tech()/dashboard/training/:slug()",
    meta: _91slug_93Ti1BDhin6mMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/dashboard/training/[slug].vue").then(m => m.default || m)
  },
  {
    name: "tech-dashboard-training",
    path: "/:tech()/dashboard/training",
    meta: indexVYKKZGzcBLMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/dashboard/training/index.vue").then(m => m.default || m)
  },
  {
    name: "tech-dashboard-upgrades",
    path: "/:tech()/dashboard/upgrades",
    meta: indexmh4NroGswmMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/dashboard/upgrades/index.vue").then(m => m.default || m)
  },
  {
    name: "tech-dashboard-vouchers",
    path: "/:tech()/dashboard/vouchers",
    meta: index3T8DDiphUYMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/dashboard/vouchers/index.vue").then(m => m.default || m)
  },
  {
    name: "tech-editor-challenge",
    path: "/:tech()/editor/:challenge()",
    meta: _91challenge_93NSfiebbjtQMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/editor/[challenge].vue").then(m => m.default || m)
  },
  {
    name: "tech-exam-id-dispute",
    path: "/:tech()/exam/:id()/dispute",
    meta: disputeSwVgtNxJvEMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/exam/[id]/dispute.vue").then(m => m.default || m)
  },
  {
    name: "tech-exam-id-done",
    path: "/:tech()/exam/:id()/done",
    meta: doneEW89200sdmMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/exam/[id]/done.vue").then(m => m.default || m)
  },
  {
    name: "tech-exam-id-progress",
    path: "/:tech()/exam/:id()/progress",
    meta: progressXf2fjnN2GtMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/exam/[id]/progress.vue").then(m => m.default || m)
  },
  {
    name: "tech-exam-id-rules",
    path: "/:tech()/exam/:id()/rules",
    meta: rulesSIRaSEz7qCMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/exam/[id]/rules.vue").then(m => m.default || m)
  },
  {
    name: "tech-exam-id-start",
    path: "/:tech()/exam/:id()/start",
    meta: startpjdeNJ66bjMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/exam/[id]/start.vue").then(m => m.default || m)
  },
  {
    name: "tech-exam-id-terms",
    path: "/:tech()/exam/:id()/terms",
    meta: termsfV0YclFPFUMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/exam/[id]/terms.vue").then(m => m.default || m)
  },
  {
    name: "tech-free-weekend",
    path: "/:tech()/free-weekend",
    meta: indexiRLgjIOHJuMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/free-weekend/index.vue").then(m => m.default || m)
  },
  {
    name: "tech-free-weekend-poll",
    path: "/:tech()/free-weekend/poll",
    meta: pollTDOb9HQ0MZMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/free-weekend/poll.vue").then(m => m.default || m)
  },
  {
    name: "tech-free-weekend-success",
    path: "/:tech()/free-weekend/success",
    meta: successLpuXJbMtyLMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/free-weekend/success.vue").then(m => m.default || m)
  },
  {
    name: "tech-login",
    path: "/:tech()/login",
    meta: indexkanhUUjdTZMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/login/index.vue").then(m => m.default || m)
  },
  {
    name: "tech-logout",
    path: "/:tech()/logout",
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/logout/index.vue").then(m => m.default || m)
  },
  {
    name: "tech-password-recover-check-email",
    path: "/:tech()/password-recover/check-email",
    meta: check_45email9kaY9TuF2jMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/password-recover/check-email.vue").then(m => m.default || m)
  },
  {
    name: "tech-password-recover",
    path: "/:tech()/password-recover",
    meta: indexEr4Dg2fSEWMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/password-recover/index.vue").then(m => m.default || m)
  },
  {
    name: "tech-password-recover-success",
    path: "/:tech()/password-recover/success",
    meta: successMnpJUSBWxMMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/password-recover/success.vue").then(m => m.default || m)
  },
  {
    name: "tech-password-reset-token",
    path: "/:tech()/password-reset/:token()",
    meta: _91token_93xY5f3RmgsgMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/password-reset/[token].vue").then(m => m.default || m)
  },
  {
    name: "tech-password-set-token",
    path: "/:tech()/password-set/:token()",
    meta: _91token_93ibSiM1IO65Meta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/password-set/[token].vue").then(m => m.default || m)
  },
  {
    name: "tech-preview-secret-mcq",
    path: "/:tech()/preview/:secret()/mcq",
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/preview/[secret]/mcq.vue").then(m => m.default || m)
  },
  {
    name: "tech-register",
    path: "/:tech()/register",
    meta: indexyXXIGdyFV8Meta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/register/index.vue").then(m => m.default || m)
  },
  {
    name: "tech-trial-exams-id-done",
    path: "/:tech()/trial-exams/:id()/done",
    meta: done7wmN4393pWMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/trial-exams/[id]/done.vue").then(m => m.default || m)
  },
  {
    name: "tech-trial-exams-id-progress",
    path: "/:tech()/trial-exams/:id()/progress",
    meta: progressN8tZfOpVCAMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/trial-exams/[id]/progress.vue").then(m => m.default || m)
  },
  {
    name: "tech-trial-exams-id-results",
    path: "/:tech()/trial-exams/:id()/results",
    meta: resultsNPp6CbdBa5Meta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/trial-exams/[id]/results.vue").then(m => m.default || m)
  },
  {
    name: "tech-trial-exams-id-rules",
    path: "/:tech()/trial-exams/:id()/rules",
    meta: rulesYOM3uaWIayMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/trial-exams/[id]/rules.vue").then(m => m.default || m)
  },
  {
    name: "tech-trial-exams-id-start",
    path: "/:tech()/trial-exams/:id()/start",
    meta: startXQvK9jTWhnMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/trial-exams/[id]/start.vue").then(m => m.default || m)
  },
  {
    name: "tech-trial-exams-id-terms",
    path: "/:tech()/trial-exams/:id()/terms",
    meta: termsakxJY1BCjvMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/trial-exams/[id]/terms.vue").then(m => m.default || m)
  },
  {
    name: "tech-verify-email-id-hash",
    path: "/:tech()/verify-email/:id()/:hash()",
    meta: _91hash_93J0C5xwZCNKMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/verify-email/[id]/[hash].vue").then(m => m.default || m)
  },
  {
    name: "tech-voucher-code",
    path: "/:tech()/voucher/:code()",
    meta: _91code_934Arf272LANMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/[tech]/voucher/[code].vue").then(m => m.default || m)
  },
  {
    name: "angular",
    path: "/angular",
    meta: indexrjHO63KsAoMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/angular/index.vue").then(m => m.default || m)
  },
  {
    name: "angular-legal-slug",
    path: "/angular/legal/:slug()",
    meta: _91slug_93jf14EWkzQkMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/angular/legal/[slug].vue").then(m => m.default || m)
  },
  {
    name: "angular-success",
    path: "/angular/success",
    meta: successyU3zO6O0CBMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/angular/success.vue").then(m => m.default || m)
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    meta: _91slug_93XkW6otCMaQMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/blog/[slug].vue").then(m => m.default || m)
  },
  {
    name: "blog",
    path: "/blog",
    meta: index0FkMs6PoBQMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: "certificates-id-share",
    path: "/certificates/:id()/share",
    meta: shareR7m8zC1pGfMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/certificates/[id]/share.vue").then(m => m.default || m)
  },
  {
    name: "certificates",
    path: "/certificates",
    meta: indexZZQPfMAqRbMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/certificates/index.vue").then(m => m.default || m)
  },
  {
    name: "checkout-success",
    path: "/checkout/success",
    meta: successt4j0sKKOEoMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/checkout/success.vue").then(m => m.default || m)
  },
  {
    name: "free-weekend",
    path: "/free-weekend",
    meta: free_45weekendi9pswk92FuMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/free-weekend.vue").then(m => m.default || m)
  },
  {
    name: "home",
    path: "/home",
    meta: homefr0HXFBRvVMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/home.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    meta: index0y7rHUPnrVMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "javascript",
    path: "/javascript",
    meta: indexgYIw8TfuAJMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/javascript/index.vue").then(m => m.default || m)
  },
  {
    name: "javascript-legal-slug",
    path: "/javascript/legal/:slug()",
    meta: _91slug_93RVNQ1VjECsMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/javascript/legal/[slug].vue").then(m => m.default || m)
  },
  {
    name: "javascript-success",
    path: "/javascript/success",
    meta: successFd0PRBMAjMMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/javascript/success.vue").then(m => m.default || m)
  },
  {
    name: "join-team",
    path: "/join-team",
    meta: index0rVBxejX9wMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/join-team/index.vue").then(m => m.default || m)
  },
  {
    name: "legal-slug",
    path: "/legal/:slug()",
    meta: _91slug_93VSgSim9uBpMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/legal/[slug].vue").then(m => m.default || m)
  },
  {
    name: "login-provider-callback-tech",
    path: "/login/:provider()/callback/:tech?",
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/login/[provider]/callback/[[tech]].vue").then(m => m.default || m)
  },
  {
    name: "logout",
    path: "/logout",
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/logout.vue").then(m => m.default || m)
  },
  {
    name: "nuxt",
    path: "/nuxt",
    meta: indexZn5nKRVcewMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/nuxt/index.vue").then(m => m.default || m)
  },
  {
    name: "nuxt-legal-slug",
    path: "/nuxt/legal/:slug()",
    meta: _91slug_93EOiemm7DcqMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/nuxt/legal/[slug].vue").then(m => m.default || m)
  },
  {
    name: "nuxt-success",
    path: "/nuxt/success",
    meta: successe5WAbfgoMOMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/nuxt/success.vue").then(m => m.default || m)
  },
  {
    name: "onboarding-profile",
    path: "/onboarding/profile",
    meta: profilenZQ1WwZEe3Meta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/onboarding/profile.vue").then(m => m.default || m)
  },
  {
    name: "press-release",
    path: "/press-release",
    meta: press_45releaseK9yQFTgtIpMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/press-release.vue").then(m => m.default || m)
  },
  {
    name: "profile",
    path: "/profile",
    meta: profilewFOLcRvVXlMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/profile.vue").then(m => m.default || m)
  },
  {
    name: "react",
    path: "/react",
    meta: indexkCZ6sTs73zMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/react/index.vue").then(m => m.default || m)
  },
  {
    name: "react-legal-slug",
    path: "/react/legal/:slug()",
    meta: _91slug_93H2liFnGsBDMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/react/legal/[slug].vue").then(m => m.default || m)
  },
  {
    name: "react-success",
    path: "/react/success",
    meta: successp5SNYkSfyUMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/react/success.vue").then(m => m.default || m)
  },
  {
    name: "soon",
    path: "/soon",
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/soon.vue").then(m => m.default || m)
  },
  {
    name: "team-dashboard",
    path: "/team/dashboard",
    meta: dashboardQaRmOxv6JFMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/team/dashboard.vue").then(m => m.default || m)
  },
  {
    name: "team-manage",
    path: "/team/manage",
    meta: manage1PXIUGSuo4Meta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/team/manage.vue").then(m => m.default || m)
  },
  {
    name: "team-my-dashboard",
    path: "/team/my-dashboard",
    meta: my_45dashboardi8ryeObos6Meta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/team/my-dashboard.vue").then(m => m.default || m)
  },
  {
    name: "team-onboarding-orderId",
    path: "/team/onboarding/:orderId()",
    meta: _91orderId_937noWx8iRXjMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/team/onboarding/[orderId].vue").then(m => m.default || m)
  },
  {
    name: "team-progress",
    path: "/team/progress",
    meta: progress56r8p6TrTPMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/team/progress.vue").then(m => m.default || m)
  },
  {
    name: "team-vouchers",
    path: "/team/vouchers",
    meta: vouchers9Jk3CP9BOJMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/team/vouchers.vue").then(m => m.default || m)
  },
  {
    name: "typescript",
    path: "/typescript",
    meta: indexHSysWWECFvMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/typescript/index.vue").then(m => m.default || m)
  },
  {
    name: "typescript-success",
    path: "/typescript/success",
    meta: successK93OzFIsvrMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/typescript/success.vue").then(m => m.default || m)
  },
  {
    name: "voucher-code",
    path: "/voucher/:code()",
    meta: indexef2MNgYDWXMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/voucher/[code]/index.vue").then(m => m.default || m)
  },
  {
    name: "voucher-code-select",
    path: "/voucher/:code()/select",
    meta: selectxC2j6ZRuK9Meta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/voucher/[code]/select.vue").then(m => m.default || m)
  },
  {
    name: "vuejs",
    path: "/vuejs",
    meta: indexFDZstyuCDsMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/vuejs/index.vue").then(m => m.default || m)
  },
  {
    name: "vuejs-legal-slug",
    path: "/vuejs/legal/:slug()",
    meta: _91slug_93UbcypnlyyzMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/vuejs/legal/[slug].vue").then(m => m.default || m)
  },
  {
    name: "vuejs-qa-demo",
    path: "/vuejs/qa/demo",
    meta: demoJIMPY8uvKmMeta || {},
    component: () => import("/home/runner/work/certificates-app/certificates-app/pages/vuejs/qa/demo.vue").then(m => m.default || m)
  },
  {
    name: "login-index",
    path: "/login",
    meta: indexPYojpkvvjkMeta || {},
    component: () => import("~/pages/[tech]/login/index.vue").then(m => m.default || m)
  },
  {
    name: "register-index",
    path: "/register",
    meta: indexJLtB69g55vMeta || {},
    component: () => import("~/pages/[tech]/register/index.vue").then(m => m.default || m)
  },
  {
    name: "password-recover-index",
    path: "/password-recover",
    meta: indexh1aW6lpbb4Meta || {},
    component: () => import("~/pages/[tech]/password-recover/index.vue").then(m => m.default || m)
  },
  {
    name: "password-recover-success",
    path: "/password-recover/success",
    meta: successwlFTWURnPUMeta || {},
    component: () => import("~/pages/[tech]/password-recover/success.vue").then(m => m.default || m)
  },
  {
    name: "password-recover",
    path: "/password-recover/check-email",
    meta: check_45emailFdYqrMlqFqMeta || {},
    component: () => import("~/pages/[tech]/password-recover/check-email.vue").then(m => m.default || m)
  },
  {
    name: "password-reset",
    path: "/password-reset/:token",
    meta: _91token_93qLhw7WDmYUMeta || {},
    component: () => import("~/pages/[tech]/password-reset/[token].vue").then(m => m.default || m)
  },
  {
    name: "password-set",
    path: "/password-set/:token",
    meta: _91token_93jn0cdb3ri6Meta || {},
    component: () => import("~/pages/[tech]/password-set/[token].vue").then(m => m.default || m)
  }
]